module.exports = __webpack_public_path__ + "static/media/web-viewer.3294c632.png";